import React from 'react';

const FormModal = ({ show, onHide, title, children, size = "lg" }) => {
  if (!show) return null;

  return (
    <div className="admin-crud-modal-overlay" onClick={onHide}>
      <div 
        className={`admin-crud-modal ${size === 'lg' ? 'admin-crud-modal-lg' : size === 'sm' ? 'admin-crud-modal-sm' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-crud-modal-header">
          <h4 className="admin-crud-modal-title">{title}</h4>
          <button className="admin-crud-modal-close" onClick={onHide}>✕</button>
        </div>
        <div className="admin-crud-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FormModal;